import { render, staticRenderFns } from "./emarticonBefore2023.vue?vue&type=template&id=0b7fd4ff&scoped=true"
import script from "./emarticonBefore2023.vue?vue&type=script&lang=js"
export * from "./emarticonBefore2023.vue?vue&type=script&lang=js"
import style0 from "./emarticonBefore2023.vue?vue&type=style&index=0&id=0b7fd4ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7fd4ff",
  null
  
)

export default component.exports